import { ALL_TOWNS } from '@/utils/constants/towns';
import type { AppCustomConfig } from '@/types/interfaces/app';
import type { Town } from '@/types/interfaces/config';

/**
 * Алматы — город по умолчанию, когда партнер не ограничен городами
 */
export const DEFAULT_TOWN_ID = 1;

/**
 * ids городов партнера в порядке, указанном в контракте
 */
export const getContractTownIds = (
	config?: AppCustomConfig,
	towns: Town[] = ALL_TOWNS
): number[] => {
	if (!config?.town) {
		return [];
	}

	const names = Array.isArray(config.town) ? config.town : [config.town];

	return names
		.map(name => towns.find(town => town.translit_name === name)?.id)
		.filter((id): id is number => Boolean(id));
};

/**
 * Город партнера: сохраненный, если партнер в нем работает,
 * иначе первый город из контракта.
 * Нужно для партнеров, которые работают без Алматы (например только в Астане) —
 * иначе им подставляется город по умолчанию (Алматы)
 */
export const getContractTownId = (
	storedTownId: number | null,
	config?: AppCustomConfig,
	towns?: Town[]
): number => {
	const townIds = getContractTownIds(config, towns);

	if (!townIds.length) {
		return storedTownId || DEFAULT_TOWN_ID;
	}

	if (storedTownId && townIds.includes(storedTownId)) {
		return storedTownId;
	}

	return townIds[0];
};
